var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"memo-link",attrs:{"to":{ name: 'memo' }}},[_c('document-outline-icon'),_c('span',[_vm._v("創作メモ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }